import React, { useEffect, useState } from "react";
import { POOL_POINT_LIST } from "./../../utils/constants";
import Select from "./Select";
type Props = any;

const SelectPoolPoint: React.FC<Props> = ({ name, control, multiple, style, label}) => {
  const [poolpointList, setpoolpointList] = useState<any>([]);

  useEffect(() => {
    setpoolpointList(POOL_POINT_LIST)
  }, []);

  return (
    <Select 
      label={label} 
      name={name}
      control={control} 
      options={poolpointList}
      multiline={multiple}
      style={style ? style : {width: '100%'}}/>
  )
}

export default SelectPoolPoint;
